export default "__VITE_ASSET__DSCZcQFZ__"